import store from '@/store';

export default (to, from, next) => {

    return store.dispatch('get_is_enable_purchase_plans_and_addons')
        .catch(() => {})
        .then(() => {
            const enabled = store.getters.is_enable_purchase_plans_and_addons;

            if (!enabled && to.name === 'no-addons-page') {
                return Promise.reject({
                    allow: false,
                    redirect: { name: 'profile-plans-your-plan' }
                });
            }

            return Promise.resolve({ allow: true });
        });
};